import { ACTION_LABELS } from "./constants";

export function getFilterLabel(key, value) {
  if (key === "action") return ACTION_LABELS[value] || value;
  if (key === "start_date" || key === "end_date") {
    return value
      ? new Date(value).toLocaleDateString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
        })
      : value;
  }
  return value;
}
